export default "__VITE_ASSET__BguKctl3__"